import React, { useEffect, useState } from "react";
import { TiArrowDownOutline } from "react-icons/ti";
import {
  useTable,
  useFilters,
  useExpanded,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  usePagination,
  useRowSelect,
} from "react-table";
import {RiArrowUpSLine,RiArrowDownSLine} from "react-icons/ri"
import { DndProvider, useDrag, useDrop } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import update from 'immutability-helper'

import {
  ChevronDoubleLeftIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronDoubleRightIcon,
} from "@heroicons/react/solid";
import { GoSearch } from "react-icons/go";
import { Button, PageButton } from "./shared/Button";
import { useDispatch, useSelector } from "react-redux";
import { classNames } from "./shared/Utils";
import { SortIcon, SortUpIcon, SortDownIcon } from "./shared/Icons";
import { CheckBox } from "./CheckBox";
import SelectedTableData from "./SelectedTableData";
import { setItemsSelected } from "../../../../redux/slices/item/itemSlice";

// Define a default UI for filtering
function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
}) {
  const count = preGlobalFilteredRows.length;
  const [value, setValue] = React.useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  return (
    <div className="text-gray-600 focus-within:text-gray-400 flex w-full justify-end py-4 px-4 items-center ">
      <input
        type="text"
        className="border-b-2 bg-transparent relative block w-3/12border-gray placeholder-gray-100 foucs: outline-none focus:border-blue-200 transition-colors"
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        placeholder="Search"
      />

      <span className="absolute">
        <GoSearch size={15} color="#808080" />
      </span>
    </div>
  );
}

// This is a custom filter UI for selecting
// a unique option from a list

export function SelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id, render },
}) {
  // Calculate the options for filtering
  // using the preFilteredRows
  const options = React.useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach((row) => {
      options.add(row.values[id]);
    });
    return [...options.values()];
  }, [id, preFilteredRows]);

  // Render a multi-select box
  // return (
  //   <label className="flex gap-x-2 items-baseline">
  //     <span className="text-gray-100 mx-3">{render("Header")}:</span>
  //     <select
  //       className="form-select appearance-none
  //       block
  //       px-4
  //       py-1
  //       text-sm
  //       font-Montserrat
  //       text-gray-700
  //       bg-white bg-clip-padding bg-no-repeat
  //       border border-solid border-gray-100
  //       rounded-lg
  //       transition
  //       ease-in-out
  //       m-0
  //       focus:text-gray-700 focus:border-blue-100 focus:outline-none"
  //       name={id}
  //       id={id}
  //       value={filterValue}
  //       onChange={(e) => {
  //         setFilter(e.target.value || undefined);
  //       }}
  //     >
  //       <option selected>All</option>
  //       {options.map((option, i) => (
  //         <option key={i} value={option}>
  //           {option}
  //         </option>
  //       ))}
  //     </select>
  //   </label>
  // );
}
export function ProductImageCell({ value, column, row }) {
  return (
    <div className="flex items-center">
      <div className="">
        <img
          className="h-10 w-10 "
          src="https://image.shutterstock.com/image-photo/closeup-elegant-mens-shoes-on-260nw-156770609.jpg"
          alt=""
        />
      </div>
      <div className="ml-4">
        <div className="text-sm font-medium text-gray-900">{value}</div>
        <div className="text-sm text-gray-500">
          {row.original[column.emailAccessor]}
        </div>
      </div>
    </div>
  );
}
export function StatusPill({ value }) {
  const status = value ? value.toLowerCase() : "unknown";

  return (
    <span
      className={classNames(
        "px-3 py-1 uppercase leading-wide text-xs rounded-full shadow-sm",
        status.startsWith("active")
          ? "bg-green-100 text-white"
          : status.startsWith("discontinued")
          ? "bg-red-800 text-white"
          : null
      )}
    >
      {status}
    </span>
  );
}
export function AssignCell({ value, column, row }) {
  return (
    <div className="flex items-center">
      <div className="text-sm ml-2 pt-2 font-bold ">{value}</div>
    </div>
  );
}
export function ExpandCell({ value, column, row }) {
  return (
    <div>
    {console.log("row",row)}

      {row.canExpand ? (
        <span
          className="text-gray-500 text-sm font-semibold"
          {...row.getToggleRowExpandedProps({})}
        >
        {console.log("row.canExpand")}
          {row.isExpanded ? (
            <div className="flex "> <RiArrowUpSLine color="#1F78B4" size={20} fill="#1F78B4" />  { value}</div>
          ) : (
            <div className="flex ">  <RiArrowDownSLine color="#1F78B4" size={20} fill="#1F78B4" />  { value}</div>
          )}
        </span>
      ) : (
        { ...AssignCell({ value, column, row }) }
        
      )}
    </div>
  );
}


function BOMTable({ columns, data }) {
  const dispatch = useDispatch();
  // Use the state and functions returned from useTable to build your UI
  const [records, setRecords] = React.useState(data)

  const getRowId = React.useCallback(row => {
    return row.id
  }, [])
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page
    visibleColumns,

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    selectedFlatRows,

  } = useTable(
    {
      columns,
      data,
    },
    useFilters, // useFilters!
    useGlobalFilter,
    useSortBy,
    useExpanded,
    usePagination, // new
    useRowSelect,
    
    (hooks) => {
      hooks.visibleColumns.push((columns) => {
        return [
          ...columns,
          {
            Header: "Choose Items",
            id: "selection",
            Cell: ({ row }) => (
              <div className="flex flex-col ml-6">
                <CheckBox {...row.getToggleRowSelectedProps()} />
              </div>
            ),
          },
        ];
      });
    }
  );

  const Permissions = useSelector((state) => state.user.userPermissions);
  const addbomitem = Permissions.find((o) => o.codename === "add_bomitem");

  const HandleClick = () => {
    dispatch(
      setItemsSelected(
        selectedFlatRows.map((row) => {
          return { item: row.original, quantity: 90 };
        })
      )
    );
  };

  // Render the UI for your table
  return (
    <>
      {/* table */}
      <div className="mt-4 flex flex-col font-Roboto">
        <div className="-my-2 overflow-x-auto -mx-4 sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div className="flex flex-wrap  shadow overflow-hidden border-b border-t border-white bg-white sm:rounded-sm">
              {/*Filter*/}
              <h3 className="text-lg font-Montserrat font-bold mx-3 mt-2">
                {" "}
                Items{" "}
              </h3>
              <GlobalFilter
                preGlobalFilteredRows={preGlobalFilteredRows}
                globalFilter={state.globalFilter}
                setGlobalFilter={setGlobalFilter}
              />
              {/* {headerGroups.map((headerGroup) =>
                    headerGroup.headers.map((column) =>
                      column.Filter ? (
                        <div className="mt-2 sm:mt-0" key={column.id}>
                          {column.render("Filter")}
                        </div>
                      ) : null
                    )
                  )} */}
              <table
                {...getTableProps()}
                className="min-w-full bg-transparent divide-y divide-gray-200"
              >
                <thead className="border-b-8 border-white">
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        // Add the sorting props to control sorting. For this example
                        // we can add them into the header props
                        <th
                          scope="col"
                          className="group px-3 py-3 text-center text-sm font-medium bg-blue-200 text-white font-Roboto tracking-wider"
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                        >
                          <div className="flex items-center justify-between">
                            {column.render("Header")}
                            {/* Add a sort direction indicator */}
                            <span>
                              {column.isSorted ? (
                                column.isSortedDesc ? (
                                  <SortDownIcon className="w-4 h-4 text-gray-100" />
                                ) : (
                                  <SortUpIcon className="w-4 h-4 text-gray-100" />
                                )
                              ) : (
                                <SortIcon className="w-4 h-4 text-gray-100 opacity-0 group-hover:opacity-100" />
                              )}
                            </span>
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()} className="bg-white">
                  {page.map((row, index) => {
                    // new
                    prepareRow(row);
                    return (
                      <>
                      <tr
                        {...row.getRowProps()}
                        className={
                          index % 2 === 0
                            ? "bg-blue-50 border-b-8 border-white w-fit"
                            : "bg-white border-b-8 border-white w-fit"
                        }
                      >
                        {row.cells.map((cell) => {
                          return (
                            <td
                              {...cell.getCellProps()}
                              className="px-3 py-3 whitespace-nowrap"
                              role="cell"
                            >
                              {cell.column.Cell.name === "defaultRenderer" ? (
                                <div className="text-sm text-gray-500 w-fit">
                                  {cell.render("Cell")}
                                </div>
                              ) : (
                                cell.render("Cell")
                              )}
                            </td>
                          );
                        })}
                      </tr>
                     
                      </>
                    );
                  })}
                </tbody>
                <tfoot>
                  <div className="flex flex-row py-4 px-3">
                    <div>
                      <select
                        className="mt-1 form-select appearance-none
                            block
                            px-4
                            py-1
                            text-sm
                            font-Montserrat
                            bg-white bg-clip-padding bg-no-repeat
                            border border-solid border-blue-100
                            rounded-lg
                            transition
                            ease-in-out
                            m-0
                            focus:text-blue-200 focus:border-blue-100 focus:outline-none"
                        value={state.pageSize}
                        onChange={(e) => {
                          setPageSize(Number(e.target.value));
                        }}
                      >
                        {[5, 10, 20].map((pageSize) => (
                          <option
                            className="text-blue-200"
                            key={pageSize}
                            value={pageSize}
                          >
                            Show {pageSize}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* Filter rows */}
                    <div className="pt-2 px-3">
                      {/* Pagination */}
                      {/* hidden sm:flex-1 sm:flex sm:items-center sm:justify-between */}
                      <div
                        className="relative z-0 inline-flex -space-x-px"
                        aria-label="Pagination"
                      >
                        <button
                          className="rounded-l-md"
                          onClick={() => gotoPage(0)}
                          disabled={!canPreviousPage}
                        >
                          <span className="sr-only">First</span>
                          <ChevronDoubleLeftIcon
                            className="h-5 w-5 text-blue-200"
                            aria-hidden="true"
                          />
                        </button>
                        <button
                          onClick={() => previousPage()}
                          disabled={!canPreviousPage}
                        >
                          <span className="sr-only">Previous</span>
                          <ChevronLeftIcon
                            className="h-5 w-5 text-blue-200"
                            aria-hidden="true"
                          />
                        </button>
                        <div className="flex items-center justify-between">
                          <span className="text-sm text-gray-200 font-medium font-Roboto">
                            Page{" "}
                            <span className="font-medium">
                              {state.pageIndex + 1}
                            </span>{" "}
                            of{" "}
                            <span className="font-medium">
                              {pageOptions.length}
                            </span>
                          </span>
                        </div>
                        <button
                          onClick={() => nextPage()}
                          disabled={!canNextPage}
                        >
                          <span className="sr-only">Next</span>
                          <ChevronRightIcon
                            className="h-5 w-5 text-blue-200"
                            aria-hidden="true"
                          />
                        </button>
                        <button
                          className="rounded-r-md"
                          onClick={() => gotoPage(pageCount - 1)}
                          disabled={!canNextPage}
                        >
                          <span className="sr-only">Last</span>
                          <ChevronDoubleRightIcon
                            className="h-5 w-5 text-blue-200"
                            aria-hidden="true"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
      {!addbomitem === undefined || addbomitem?.codename === "add_bomitem" ? (
        <div className="flex flex-col justify-center w-full place-items-center mt-7">
          <button type="button" onClick={() => HandleClick()}>
            <TiArrowDownOutline size={50} color="#1F78B4" />
          </button>
        </div>
      ) : null}
    </>
  );
}

export default BOMTable;
